export default function() {
	$("#loginModal")
		.on('hide.bs.modal', function(e) {
			e.preventDefault();
			window.location = '/';
		})
		.modal('show');
};
